import * as React from 'react';
import { tiers } from '~config/tiers';
import { TierWithMultiplier } from '~features/tiers/components/TierName';

export function DHEligibilityRules() {
  return (
    <div className="space-y-0 mb-6">
      <p>You are eligible for Diamond Hands rewards if:</p>
      <ul className="list-disc list-inside">
        <li>
          You stake in the <b>1095d pool</b>
        </li>
        <li>
          For the DH75 rewards, a guaranteed tier, at least an AFFILIATE [2x]
          level and a participation in the token's sale is required
        </li>
        <li>
          For the DH25 rewards, you must have a tier of AAG, SAAG levels. AAG
          levels start at the <TierWithMultiplier tier={tiers.associate} />{' '}
          level.
        </li>
      </ul>
    </div>
  );
}
